(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cep-hover-image"] && !Shopify.designMode) return;
  try {
    (function () {
  function build(card) {
    if (!card || card.dataset.cepHoverBuilt) return;
    card.dataset.cepHoverBuilt = '1';
    card.querySelectorAll('figure[data-cep-hover]').forEach(function (fig) {
      var img = document.createElement('img');
      img.className = 'lazy-loading-image--main';
      img.alt = '';
      img.width = fig.dataset.cepHoverW;
      img.height = fig.dataset.cepHoverH;
      img.sizes = '(min-width: 991px) 25vw, (min-width: 768px) 33vw, 50vw';
      var base = fig.dataset.cepHover + (fig.dataset.cepHover.indexOf('?') > -1 ? '&' : '?') + 'width=';
      img.srcset = [375, 550, 750, 1100].map(function (w) { return base + w + ' ' + w + 'w'; }).join(', ');
      img.src = base + 750;
      fig.classList.add('lazy-loading-image');
      img.addEventListener('load', function () { fig.classList.add('lazy-loaded-image'); });
      fig.appendChild(img);
      fig.removeAttribute('data-cep-hover');
    });
  }
  function onEvent(e) {
    var card = e.target.closest && e.target.closest('.product');
    if (card) build(card);
  }
  document.addEventListener('pointerover', onEvent, { passive: true });
  document.addEventListener('focusin', onEvent);
  document.addEventListener('touchstart', onEvent, { passive: true, capture: true });
})();
  } catch(e) { console.error(e); }
})();

})();
